import React from 'react';
import swal from 'sweetalert';
import {Link} from 'react-router-dom';

import clientData from '../../inc/clientData';
import config from '../../inc/config';
import Images from '../../utils/Images';

class MailValidationModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      mailValidate: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    console.log("Consultants: componentDidMount()");
  }

  componentWillUnmount() {
    console.log("Consultants: componentWillUnmount()");
  }

  handleMailValidation = () => {
    this.setState({ mailValidate: true });
  }

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <div className="mt-2">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <h3 className="text-darkblue">E-posta</h3>
          </div>
        </div>
        <div className="hr-line-dashed mt-0"></div>
        <div className="row">
          {this.state.mailValidate === false &&
          <div className="col my-2">
            <div className="table-responsive-lg">
              <h4 className="text-darkblue col-md-6 p-0">İlanlarınız, favorileriniz ve mesajlarınız ile ilgili önemli e-posta'ların size ulaştığından emin olabilmek için ve hesap işlemleri için lütfen güncel e-posta adresinizi doğrulayın.</h4>
              <h4 className="text-darkblue col-md-6 p-0">Kayıtlı e-posta adresiniz: <b>b.yildirim@satisgaranti.com</b></h4>
              <button className="btn bg-orange text-white my-2" onClick={() => this.setState({mailValidate: true})} title="E-posta ile Doğrula"><i className="fa fa-id-card mr-1"></i>E-posta ile Doğrula</button>
              <div>
                  <img className="mb-4 mt-0" src={Images.mailValidation}/>
              </div>
            </div>
          </div>
          }
          {this.state.mailValidate === true &&
          <div className="col my-2">
            <div className="table-responsive-lg">
              <h4 className="text-darkblue col-md-6 p-0">Güvenliğiniz için öncelikle, kayıtlı <b>b.yildirim@satisgaranti.com</b> adresinize gönderdiğimiz onay kodunu aşağıdaki alana girin.</h4>
              <h4>Onay Kodu</h4>
              <input className="col-3 form-control form-input mb-2 mt-2" /* onChange={(event) => this.setState({validationCode: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} */ placeholder="Onay Kodu" /* value={this.state.validationCode} *//>
              <button className="btn bg-orange text-white my-2" title="Devam Et"><i className="fa fa-id-card mr-1"></i>Devam Et</button>
            </div>
          </div>
          }
        </div>
      </div>
  }
}

export default function MailValidation() {
  return (
    <MailValidationModule />
  )
}